/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVolumeCross: {
  name: 'volume-cross';
  data: string;
} = {
  name: 'volume-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.838 4.316C14.16 3.37 16 4.316 16 5.943v12.334c0 1.535-1.659 2.498-2.992 1.736L7.734 17H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3.68l5.158-3.684ZM14 5.943 8.842 9.627A2 2 0 0 1 7.68 10H4v5h3.734a2 2 0 0 1 .993.264L14 18.276V5.943Zm4.293 4.35a1 1 0 0 1 1.414 0l.793.793.793-.793a1 1 0 1 1 1.414 1.414l-.793.793.793.793a1 1 0 0 1-1.414 1.414l-.793-.793-.793.793a1 1 0 0 1-1.414-1.414l.793-.793-.793-.793a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
